export default __webpack_public_path__ + "static/accountantsVp1-887717c579352144cc66e5417cdf0988.png";